import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { trackPixelEvent } from '../../utils/metaPixel';
import { PENDING_PURCHASE_KEY } from '../../services/stripe/checkout';

const FIRED_PREFIX = 'meta_pixel_purchase_fired:';

// Stripe redirects back to /dashboard?session_id=...&success=true after a
// confirmed payment. This detects that redirect, fires Purchase exactly once
// per session_id, then strips the params so a page refresh can't refire it.
export default function MetaPixelPurchaseTracker() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('success') !== 'true') return;

    const sessionId = searchParams.get('session_id');
    const firedKey = sessionId ? `${FIRED_PREFIX}${sessionId}` : null;

    if (firedKey && !localStorage.getItem(firedKey)) {
      let pending = null;
      try {
        pending = JSON.parse(sessionStorage.getItem(PENDING_PURCHASE_KEY) || 'null');
      } catch {
        pending = null;
      }

      trackPixelEvent('Purchase', {
        value: pending?.value ?? 0,
        currency: pending?.currency ?? 'PLN',
      });

      localStorage.setItem(firedKey, '1');
      sessionStorage.removeItem(PENDING_PURCHASE_KEY);
    }

    const next = new URLSearchParams(searchParams);
    next.delete('success');
    next.delete('session_id');
    next.delete('canceled');
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return null;
}
